import { render, staticRenderFns } from "./BlockGroupHelplist.vue?vue&type=template&id=a68b73cc&"
import script from "./BlockGroupHelplist.vue?vue&type=script&lang=js&"
export * from "./BlockGroupHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports